import type { ComponentClass, FunctionComponent } from 'react';

import StringsContext from '../contexts/StringsContext';

type ComponentFunction<Props> =
  FunctionComponent<Props> | ComponentClass<Props>;

function getDisplayName<Props extends {}>(
  WrappedComponent: ComponentFunction<Props>,
) {
  return WrappedComponent.displayName || WrappedComponent.name;
}

const withStrings = <Props extends {}>(
  WrappedComponent: ComponentFunction<Props>,
) => {
  const WithStrings = (props: any) => (
    <StringsContext.Consumer>
      {(strings) => <WrappedComponent strings={strings} {...props} />}
    </StringsContext.Consumer>
  );

  WithStrings.displayName = `WithStrings(${getDisplayName(WrappedComponent)})`;

  return WithStrings;
};

export default withStrings;
